import { FC, ReactNode } from 'react';
import './AuxiliaryActions.scss';

type Props = {
  children: ReactNode;
};
export const AuxiliaryActions: FC<Props> = ({ children }) => {
  return <div className='auxiliary-actions'>{children}</div>;
};
